// Utility functions for post content and images
import { db } from '../../context/Firebase';
import { doc, getDoc } from 'firebase/firestore';

export const getPostContent = (post) => {
  const content = post.post || post.description || post.content || post.text || "";
  return content.trim();
};

/**
 * Check if a hashtag is blocked or reported in Firestore.
 * @param {string} tag - hashtag without #
 * @returns {Promise<boolean>}
 */
export const isHashtagBlocked = async (tag) => {
  try {
    const snap = await getDoc(doc(db, "hashtags", tag.toLowerCase()));
    if (snap.exists()) {
      const data = snap.data();
      return data.isBlocked === true || data.isReported === true;
    }
  } catch (err) {
    console.error("Error checking hashtag:", err);
  }
  return false;
};

export const renderContentWithHashtags = (content, onHashtagClick) => {
  if (!content) return null;
  
  const parts = content.split(/(#\w+)/g);
  return parts.map((part, index) => {
    if (part.startsWith('#')) {
      return (
        <span
          key={index}
          style={{ color: '#1877f2', cursor: 'pointer', fontWeight: 500 }}
          onClick={(e) => {
            e.stopPropagation();
            if (onHashtagClick) {
              onHashtagClick(part);
            }
          }}
        >
          {part}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
};

export const getPostImages = (post) => {
  if (post.postImg) return [post.postImg];
  if (Array.isArray(post.postImages) && post.postImages.length > 0) {
    if (post.postImages[0]?.postImg) {
      return post.postImages.map(item => item.postImg);
    }
    if (typeof post.postImages[0] === 'string') {
      return post.postImages;
    }
  }
  if (post.postImages?.postImg) return [post.postImages.postImg];
  if (post.imageUrl) return [post.imageUrl];
  if (post.image) return [post.image];
  if (Array.isArray(post.images)) return post.images;
  if (post.postImage) return [post.postImage];
  if (post.url) return [post.url];
  return [];
};
